import React from "react";
import './dashboard.css'
import Login from "../Login/login";
import { useState,useEffect } from "react"
import Navdashboard from "./navdashboard";
import AddObjet from "./addObjet";
import ObjetCommandeView from "./objetCommandeView";
function Dashboard(){
    let [ViewContent,setviewContent] = useState('dashObjet')
    const handeleAbbObjet = () => {
        setviewContent('addObjet')
    }
    const handeleDeletObjet = () =>{
        setviewContent('deletObjet')

    }
    const handeledash = () =>{
        setviewContent('dashObjet')

    }
    const handeleViewObjet = () =>{
        setviewContent('viewObjet')

    }
   const view = (ViewContent)=>{
        if (ViewContent === 'addObjet'){
            
            return <AddObjet/>
        }else 
        if (ViewContent === 'deletObjet'){
            return <ObjetCommandeView dashOrView={'delete'}/>
        }else 
        if (ViewContent === 'viewObjet'){
            return <ObjetCommandeView dashOrView={'view'}/>
        }else 
        if (ViewContent === 'dashObjet'){
            return <ObjetCommandeView dashOrView={'dash'}/>

        }
    }
   
    
    return <div className="bg-dashboard">
                <aside className="block-navboad" >
                    <Navdashboard handeleAbbObjet={handeleAbbObjet} 
                    handeleDeletObjet={handeleDeletObjet} 
                    handeleViewObjet={handeleViewObjet}
                    handeledash={handeledash}/>
                </aside>
                <div className="content">
                    <div className="logoDash">
                        {/* <Logoboard/> */}
                    </div>
                    {view(ViewContent)}
                </div>
           </div>
}
export default Dashboard